export default __webpack_public_path__ + "static/media/draggable-container.5ddfecbc.png";